import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { useTranslation } from "react-i18next";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const AnimatedNumber = ({ value, prefix = "", suffix = "" }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [display, setDisplay] = useState(0);
  const target = parseInt(value, 10);

  useEffect(() => {
    if (!isInView) return;
    const duration = 1500;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setDisplay(target);
        clearInterval(timer);
      } else {
        setDisplay(Math.round(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [isInView, target]);

  return (
    <span ref={ref} className="text-2xl lgl:text-3xl font-bold text-white font-titleFont">
      {prefix}{display}{suffix}
    </span>
  );
};

const StatsCell = () => {
  const { t } = useTranslation();

  const stats = [
    { value: t("bento.stats.years"), prefix: "+", label: t("bento.stats.yearsLabel") },
    { value: t("bento.stats.conversions"), prefix: "+", suffix: "%", label: t("bento.stats.conversionsLabel") },
    { value: t("bento.stats.projects"), suffix: "+", label: t("bento.stats.projectsLabel") },
    { value: t("bento.stats.team"), label: t("bento.stats.teamLabel") },
  ];

  return (
    <motion.div
      variants={item}
      className="bento-cell p-4 lgl:p-6 grid grid-cols-2 lgl:grid-cols-4 gap-4 items-center
                 lgl:col-start-6 lgl:col-end-11 lgl:row-start-3 lgl:row-end-4"
    >
      {stats.map((stat, i) => (
        <div key={i} className="flex flex-col items-center text-center gap-1 py-2">
          <AnimatedNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} />
          <span className="text-xs text-gray-500 uppercase tracking-wider">{stat.label}</span>
        </div>
      ))}
    </motion.div>
  );
};

export default StatsCell;
